import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const savedLang = typeof localStorage !== 'undefined' ? localStorage.getItem('abilityos_lang') || 'en' : 'en';

const resources = {
  en: {
    translation: {
      "app_name": "AbilityOS",
      "tagline": "Empowering Every Ability",
      "saas_overview": "SaaS Overview",
      "module_suite": "30-Module Suite",
      "apps_downloads": "Apps & Downloads",
      "aac_board": "AAC Speech Board",
      "analytics": "Analytics",
      "super_admin": "Super Admin Plane",
      "school_admin": "School Admin Workspace",
      "sign_in": "Sign In / Demo Login",
      "sign_out": "Sign Out",
      "hero_title": "Empowering Every Student & Therapist with AI-Driven Precision",
      "hero_desc": "AbilityOS brings together AAC speech synthesis, automated IEP goal management, speech therapy, autism ABA tracking, tele-rehabilitation, bionic prosthetics, hydrotherapy, and 30 specialized modules into one unified enterprise platform.",
      "get_started_free": "Get Started Free",
      "download_apps_btn": "Download Native Apps (All OS)",
      "live_sandbox": "Live Interactive Sandbox (No Login Needed)",
      "speak_voice": "Speak Voice",
      "type_phrase": "Type phrase to speak...",
      "save": "Save",
      "cancel": "Cancel",
      "high_contrast": "High Contrast Mode",
      "font_dyslexic": "OpenDyslexic Font",
      "language": "Language",
      "students_supported": "50,000+ Students Supported",
      "schools_supported": "1,400+ Special Schools",
      "modules_count": "30 Specialized Modules",
      "wcag_rating": "WCAG 2.2 AAA Accessible",

      // Admin & Subscriptions
      "tenant_admins_title": "Tenant Administrator Accounts & Subscription Licensing",
      "grant_subscription": "Grant Valid Subscription",
      "revoke_subscription": "Revoke Subscription",
      "subscription_active": "Subscription Active",
      "subscription_expired": "Subscription Expired",
      "add_tenant_admin": "Add New Tenant Admin",
      "student_roster": "Student Roster",
      "add_student": "Enrol Student",
      "bulk_excel": "Bulk Upload Excel",

      // 30 Modules
      "mod_aac": "1. AAC Speech Synthesizer",
      "mod_speech": "2. Speech & Articulation",
      "mod_autism": "3. Autism & ABA Behavior",
      "mod_sign": "4. Sign Language & Gestures",
      "mod_braille": "5. Braille & Tactile Learning",
      "mod_student": "6. Student & IEP Progress",
      "mod_therapist": "7. Therapist Workspace & SOAP",
      "mod_teacher": "8. Teacher & Classroom",
      "mod_assessment": "9. Diagnostic Assessment",
      "mod_erp": "10. Special School ERP",
      "mod_hospital": "11. Rehabilitation Hospital",
      "mod_billing": "12. NDIS & Insurance Billing",
      "mod_comm": "13. Parent Communication",
      "mod_inventory": "14. Assistive Device Inventory",
      "mod_analytics": "15. Executive Analytics BI",
      "mod_ai": "16. AI Copilot Summarizer",
      "mod_sensory": "17. Sensory Room Controller",
      "mod_tele": "18. Tele-Rehabilitation Video",
      "mod_early": "19. Early Intervention Milestone",
      "mod_vocal": "20. Vocational & Life Skills",
      "mod_hydro": "21. Hydrotherapy Aquatic Rehab",
      "mod_music": "22. Music & Auditory Stimulation",
      "mod_animal": "23. Animal-Assisted Therapy",
      "mod_prosthetics": "24. Bionic Prosthetics & Exoskeleton",
      "mod_vbmapp": "25. VB-MAPP Behavioral Assessment",
      "mod_core_vocab": "26. Motor Core Vocab & AI Predictor",
      "mod_fim": "27. FIM Functional Independence",
      "mod_evv": "28. EVV Visit Verification & GPS",
      "mod_neuro": "29. WebGL Biofeedback Neuro-Rehab",
      "mod_transition": "30. Transition & Vocational Matrix",
      "mod_audiometry": "31. Pure-Tone Audiometry Hearing Screener"
    }
  },
  hi: {
    translation: {
      "app_name": "एबिलिटी-ओएस",
      "tagline": "हर क्षमता को सशक्त बनाना",
      "saas_overview": "सास अवलोकन",
      "module_suite": "30-मॉडल सूट",
      "apps_downloads": "ऐप्स और डाउनलोड",
      "aac_board": "एएसी स्पीच बोर्ड",
      "analytics": "एनालिटिक्स",
      "super_admin": "सुपर एडमिन नियंत्रण",
      "school_admin": "स्कूल एडमिन वर्कस्पेस",
      "sign_in": "साइन इन / डेमो लॉगिन",
      "sign_out": "साइन आउट",
      "hero_title": "एआई-संचालित सटीकता के साथ हर छात्र और चिकित्सक को सशक्त बनाना",
      "hero_desc": "एबिलिटी-ओएस एएसी वाक् संश्लेषण, स्वचालित आईईपी लक्ष्य प्रबंधन, वाक् चिकित्सा, ऑटिज्म एबीए ट्रैकिंग, टेली-पुनर्वास, हाइड्रोथेरेपी और 30 विशेष मॉडलों को एक एकीकृत मंच में लाता है।",
      "get_started_free": "मुफ्त शुरू करें",
      "download_apps_btn": "नेटिव ऐप्स डाउनलोड करें (सभी OS)",
      "live_sandbox": "लाइव इंटरैक्टिव सैंडबॉक्स (लॉगिन की आवश्यकता नहीं)",
      "speak_voice": "आवाज़ बोलें",
      "type_phrase": "बोलने के लिए वाक्यांश टाइप करें...",
      "save": "सुरक्षित करें",
      "cancel": "रद्द करें",
      "high_contrast": "उच्च कंट्रास्ट मोड",
      "font_dyslexic": "ओपन-डिस्लेक्सिक फ़ॉन्ट",
      "language": "भाषा",
      "students_supported": "50,000+ छात्र समर्थित",
      "schools_supported": "1,400+ विशेष स्कूल",
      "modules_count": "30 विशेष मॉडल",
      "wcag_rating": "WCAG 2.2 AAA सुलभ",

      // Admin & Subscriptions
      "tenant_admins_title": "टेनेट प्रशासक खाते एवं सदस्यता लाइसेंसिंग",
      "grant_subscription": "वैध सदस्यता प्रदान करें",
      "revoke_subscription": "सदस्यता रद्द करें",
      "subscription_active": "सदस्यता सक्रिय",
      "subscription_expired": "सदस्यता समाप्त",
      "add_tenant_admin": "नया टैलेंट एडमिन जोड़ें",
      "student_roster": "छात्र सूची",
      "add_student": "छात्र नामांकित करें",
      "bulk_excel": "थोक एक्सेल अपलोड करें",

      // 30 Modules
      "mod_aac": "1. एएसी वाक् संश्लेषक",
      "mod_speech": "2. वाक् चिकित्सा एवं उच्चारण",
      "mod_autism": "3. ऑटिज्म और एबीए व्यवहार",
      "mod_sign": "4. सांकेतिक भाषा और इशारे",
      "mod_braille": "5. ब्रेल और स्पर्श अधिगम",
      "mod_student": "6. छात्र और आईईपी प्रगति",
      "mod_therapist": "7. थेरेपिस्ट वर्कस्पेस और एसओएपी",
      "mod_teacher": "8. शिक्षक और कक्षा",
      "mod_assessment": "9. नैदानिक मूल्यांकन",
      "mod_erp": "10. विशेष स्कूल ईआरपी",
      "mod_hospital": "11. पुनर्वास अस्पताल",
      "mod_billing": "12. एनडीआईएस और बिलिंग",
      "mod_comm": "13. माता-पिता संचार",
      "mod_inventory": "14. सहायक उपकरण इन्वेंटरी",
      "mod_analytics": "15. कार्यकारी एनालिटिक्स बीआई",
      "mod_ai": "16. एआई सह-पायलट सारांश",
      "mod_sensory": "17. संवेदी कक्ष नियंत्रक",
      "mod_tele": "18. टेली-पुनर्वास वीडियो",
      "mod_early": "19. प्रारंभिक हस्तक्षेप मील का पत्थर",
      "mod_vocal": "20. व्यावसायिक एवं जीवन कौशल",
      "mod_hydro": "21. हाइड्रोथेरेपी जलीय पुनर्वास",
      "mod_music": "22. संगीत और श्रवण उत्तेजना",
      "mod_animal": "23. पशु-सहायता प्राप्त चिकित्सा",
      "mod_prosthetics": "24. बायोनिक प्रोस्थेटिक्स और एक्सोस्केलेटन",
      "mod_vbmapp": "25. वीबी-एमएपीपी व्यावहारिक मूल्यांकन",
      "mod_core_vocab": "26. मोटर कोर शब्दावली एवं एआई",
      "mod_fim": "27. एफआईएम कार्यात्मक स्वतंत्रता स्कोरिंग",
      "mod_evv": "28. ईवीवी यात्रा सत्यापन एवं जीपीएस",
      "mod_neuro": "29. वेबजीएल बायोफीडबैक न्यूरो-रिहैब",
      "mod_transition": "30. संक्रमण और व्यावसायिक मैट्रिक्स",
      "mod_audiometry": "31. शुद्ध-स्वर ऑडियोमेट्री श्रवण परीक्षण"
    }
  },
  mr: {
    translation: {
      "app_name": "ॲबिलिटी-ओएस",
      "tagline": "प्रत्येक क्षमतेला सक्षम करणे",
      "saas_overview": "सास विहंगावलोकन",
      "module_suite": "30-मॉड्यूल सूट",
      "apps_downloads": "ॲप्स आणि डाऊनलोड्स",
      "aac_board": "एएसी संभाषण बोर्ड",
      "analytics": "ॲनालिटिक्स",
      "super_admin": "सुपर ॲडमिन नियंत्रण",
      "school_admin": "शाळा ॲडमिन कार्यक्षेत्र",
      "sign_in": "साइन इन / डेमो लॉगिन",
      "sign_out": "साइन आऊट",
      "hero_title": "एआई-चलित अचूकतेने प्रत्येक विद्यार्थी आणि थेरपिस्टला सक्षम करणे",
      "hero_desc": "ॲबिलिटी-ओएस एएसी स्पीच संश्लेषण, स्वयंचलित आयईपी ध्येय व्यवस्थापन, स्पीच थेरपी, ऑटिझम एबीए ट्रॅकिंग आणि 30 विशेष मॉड्यूल्स एका एकात्मिक व्यासपीठावर आणते.",
      "get_started_free": "विनामूल्य सुरू करा",
      "download_apps_btn": "नेटिव्ह ॲप्स डाऊनलोड करा (सर्व OS)",
      "live_sandbox": "थेट परस्परसंवादी सँडबॉक्स (लॉगिन आवश्यक नाही)",
      "speak_voice": "आवाज बोला",
      "type_phrase": "बोलण्यासाठी वाक्य टाईप करा...",
      "save": "जतन करा",
      "cancel": "रद्द करा",
      "high_contrast": "उच्च कॉन्ट्रास्ट मोड",
      "font_dyslexic": "ओपन-डिस्लेक्सिक फॉन्ट",
      "language": "भाषा",
      "students_supported": "50,000+ विद्यार्थी समर्थित",
      "schools_supported": "1,400+ विशेष शाळा",
      "modules_count": "30 विशेष मॉड्यूल्स",
      "wcag_rating": "WCAG 2.2 AAA सुलभ",

      // Admin & Subscriptions
      "tenant_admins_title": "टेनेन्ट प्रशासक खाती आणि सबस्क्रिप्शन परवाना",
      "grant_subscription": "वैध सबस्क्रिप्शन प्रदान करा",
      "revoke_subscription": "सबस्क्रिप्शन रद्द करा",
      "subscription_active": "सबस्क्रिप्शन सक्रिय",
      "subscription_expired": "सबस्क्रिप्शन कालबाह्य",
      "add_tenant_admin": "नवीन ॲडमिन जोडा",
      "student_roster": "विद्यार्थी यादी",
      "add_student": "विद्यार्थी नोंदवा",
      "bulk_excel": "एक्सेल अपलोड करा",

      // 30 Modules
      "mod_aac": "1. एएसी स्पीच सिंथेसायझर",
      "mod_speech": "2. स्पीच थेरपी आणि उच्चार",
      "mod_autism": "3. ऑटिझम आणि एबीए वर्तन",
      "mod_sign": "4. सांकेतिक भाषा आणि जेश्चर",
      "mod_braille": "5. ब्रेल आणि स्पर्श शिक्षण",
      "mod_student": "6. विद्यार्थी आणि आयईपी प्रगती",
      "mod_therapist": "7. थेरपिस्ट कार्यक्षेत्र आणि एसओएपी",
      "mod_teacher": "8. शिक्षक आणि वर्ग",
      "mod_assessment": "9. निदान मूल्यांकन",
      "mod_erp": "10. विशेष शाळा ईआरपी",
      "mod_hospital": "11. पुनर्वसन रुग्णालय",
      "mod_billing": "12. एनडीआईएस आणि बिलिंग",
      "mod_comm": "13. पालक संवाद",
      "mod_inventory": "14. सहाय्यक उपकरण वस्तूंची यादी",
      "mod_analytics": "15. कार्यकारी ॲनालिटिक्स बीआई",
      "mod_ai": "16. एआई सह-पायलट सारांश",
      "mod_sensory": "17. सेन्सर रूम कंट्रोलर",
      "mod_tele": "18. टेलि-रिहॅबिलिटेशन व्हिडिओ",
      "mod_early": "19. सुरुवातीचा टप्पा ट्रॅकर",
      "mod_vocal": "20. व्यावसायिक आणि जीवन कौशल्ये",
      "mod_hydro": "21. हायड्रोथेरपी ॲक्वाटिक रिहॅब",
      "mod_music": "22. म्युझिक आणि ऑडिओ उद्दीपन",
      "mod_animal": "23. प्राणी-सहाय्यित थेरपी",
      "mod_prosthetics": "24. बायोनिक प्रोस्थेटिक्स आणि एक्सोस्केलेटन",
      "mod_vbmapp": "25. वीबी-एमएपीपी वर्तन मूल्यांकन",
      "mod_core_vocab": "26. मोटार कोर शब्दसंग्रह आणि एआय",
      "mod_fim": "27. एफआईएम कार्यात्मक स्वामित्त्व स्कोअरिंग",
      "mod_evv": "28. ईव्हिव्ह भेट पडताळणी आणि जीपीएस",
      "mod_neuro": "29. वेबजीएल बायोफीडबॅक न्यूरो-रिहॅब",
      "mod_transition": "30. संक्रमण आणि व्यावसायिक मॅट्रिक्स",
      "mod_audiometry": "31. शुद्ध-स्वर ऑडिओमेट्री श्रवण चाचणी"
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLang,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

i18n.on('languageChanged', (lng) => {
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem('abilityos_lang', lng);
  }
  document.documentElement.lang = lng;
});

export default i18n;
